import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import { IInTakeSurveyQuestionMeta } from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../builders/ap_intake_survey_question_choice_builder';

// as agreed during the KO meetinga assigning the default values
// https://workflow.advisory.com/browse/NAV-5520
const timeCommitmentDefaultAnswer = (choices: IInTakeSurveyQuestionChoice[]) => ({
  ..._4.find(choices, { nk: 'FULL_TIME' })
});

const planExperienceDefaultAnswer = (choices: IInTakeSurveyQuestionChoice[]) => ({
  ..._4.find(choices, { nk: 'GENERATE_PLAN' })
});

const preferenceDefaultAnswer = (choices: IInTakeSurveyQuestionChoice[]) => [
  ..._4.filter(choices, (choice: IInTakeSurveyQuestionChoice) => _4.includes(['SPRING', 'FALL'], _4.toUpper(choice.nk)))
];

export const ApIntakeSurveyDefaultAnswerStrategy = new Strategy({
  AP_TIME_COMMITMENT: timeCommitmentDefaultAnswer,
  AP_GENERATE_PLAN: planExperienceDefaultAnswer,
  AP_TERM_PREFERENCE: preferenceDefaultAnswer
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/strategies/ap_intake_survey_default_answer_strategy.ts